import type { Vec2 } from '@/lib/companion/types';

export interface Bounds {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

const clamp01 = (n: number): number => Math.min(1, Math.max(0, n));

/** The travellable span: the sprite's own size is excluded so a normalized 1
 *  means "flush with the corner, fully visible", not "one sprite off-screen". */
const spans = (bounds: Bounds, petW: number, petH: number) => ({
  x: Math.max(0, bounds.right - bounds.left - petW),
  y: Math.max(0, bounds.bottom - bounds.top - petH),
});

export function toNormalized(pos: Vec2, bounds: Bounds, petW: number, petH: number): Vec2 {
  const span = spans(bounds, petW, petH);
  return {
    x: span.x === 0 ? 0 : clamp01((pos.x - bounds.left) / span.x),
    y: span.y === 0 ? 0 : clamp01((pos.y - bounds.top) / span.y),
  };
}

export function fromNormalized(norm: Vec2, bounds: Bounds, petW: number, petH: number): Vec2 {
  const span = spans(bounds, petW, petH);
  return {
    x: bounds.left + clamp01(norm.x) * span.x,
    y: bounds.top + clamp01(norm.y) * span.y,
  };
}

export function clampToBounds(pos: Vec2, bounds: Bounds, petW: number, petH: number): Vec2 {
  const span = spans(bounds, petW, petH);
  return {
    x: Math.min(bounds.left + span.x, Math.max(bounds.left, pos.x)),
    y: Math.min(bounds.top + span.y, Math.max(bounds.top, pos.y)),
  };
}
